import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAgentQuery } from "web_myplann/Api/Advisor/useAgentQuery";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import type { ChatPageState } from "web_myplann/Chat/Hooks/useChatPage";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { device } from "web_myplann/Utils/device";

export const useGoalAdvisorChat = (goal: GoalDetail | undefined) => {
	const { data: agent } = useAgentQuery(goal?.agent?.id);
	const navigate = useNavigate();
	const hasGoalsRight = useGoalsRightOptional();

	return useCallback(
		(message: string) => {
			if (hasGoalsRight) {
				const conversationId = agent?.conversationId;
				navigate(
					Routing.Chat.Detail.path(
						conversationId ? String(conversationId) : "new",
						agent?.uid,
					),
					{ state: { draftMessage: message } satisfies ChatPageState },
				);
				return;
			}

			device.navigateChatRequest(
				String(agent?.conversationId ?? ""),
				agent?.conversationTitle ?? agent?.name ?? goal?.agent?.name ?? "",
				agent?.uid,
				message,
			);
		},
		[agent, goal?.agent?.name, navigate, hasGoalsRight],
	);
};
